import * as React from 'react';

import { cn } from '@/lib/utils';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
export {
  EmptyState,
  PageHero,
  PageIntro,
  PageSection,
  SectionPill,
  SectionStack,
  SurfacePanel,
} from '@/components/site/page-primitives';

type SiteShellProps = {
  children: React.ReactNode;
  variant?: ShellVariant;
  hero?: React.ReactNode;
  className?: string;
  mainClassName?: string;
  contentClassName?: string;
};
type ShellVariant = 'marketing' | 'app' | 'utility';

export function SiteShell({
  children,
  variant = 'marketing',
  hero,
  className,
  mainClassName,
  contentClassName,
}: SiteShellProps) {
  const mainWidthClass = 'site-shell-wide';
  const mainVariantClass = variant === 'marketing' ? 'site-main-marketing' : undefined;

  return (
    <div
      className={cn(
        'site-shell',
        variant === 'marketing' && 'site-shell-marketing',
        variant === 'app' && 'site-shell-app-surface',
        variant === 'utility' && 'site-shell-utility',
        className,
      )}
    >
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-[var(--site-primary-fill)] focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-[var(--site-primary-text)]"
      >
        Перейти к содержимому
      </a>
      <Navbar variant={variant} />
      <main id="main-content" className={cn('site-main', mainVariantClass, mainClassName)}>
        <div className={cn('site-shell-frame', mainWidthClass, contentClassName)}>
          {hero}
          {children}
        </div>
      </main>
      <Footer variant={variant} />
    </div>
  );
}

export function MarketingPageShell(props: Omit<SiteShellProps, 'variant'>) {
  return <SiteShell variant="marketing" {...props} />;
}

export function AppPageShell(props: Omit<SiteShellProps, 'variant'>) {
  return <SiteShell variant="app" {...props} />;
}

export function UtilityPageShell(props: Omit<SiteShellProps, 'variant'>) {
  return <SiteShell variant="utility" {...props} />;
}
